import * as React from "react";
import * as main from "../../main.module.scss";
import * as screen1 from "./style.module.scss";
export const Screen1 = () => {
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <div className={screen1.inner}>
          <div className={screen1.info}>
            <p className={screen1.sup}>Онлайн-курс для детей 6–10 лет и их родителей</p>
            <h1>Учись учиться.<br/>Начало</h1>
            <p className={screen1.sub}>Инструменты для успеха в школе и в жизни</p>
            <ul>
              <li>Научим чтению и пониманию текстов</li>
              <li>Разовьем навыки, необходимые школьнику для успешного обучения</li>
              <li>Курс состоит из тренажёра для детей и инструкций для родителей</li>
            </ul>
            <a href={"#widget"} className={main.btn}>Купить курс</a>
          </div>
        </div>
        <div className={screen1.recs}>
          <p>
            Курс рекомендован Навигатором образования Минпросвещения России и Смартекой
          </p>
          <div className={screen1.imgs}>
            <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/logo-minprosvet.svg" alt="Минпросвещения России"/>
            <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/logo-smarteka.png" alt="Смартека"/>
          </div>
        </div>
      </div>
    </section>
  );
};
